import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { AppConstants } from "../../constants/app-constants";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CandidateService {
  JWTToken;

  constructor(private http: HttpClient) { }


  //Parser Util   commented by hari
  parse(file) {
    // const url = environment.PARSER_URL; //+ 'parser'
    const url = environment.SERVER_URL + AppConstants.PARSE_PDF;
    const body = new FormData();
    body.append('bytes', file);
    return this.http.post(url, body);
  }


  AIparse(file) {
    // const url = AppConstant.PARSER_URL; //+ 'parser'
    const url = environment.SERVER_URL + AppConstants.AI_PARSER
    const body = new FormData();
    body.append('bytes', file);
    return this.http.post(url, body);
  }

  // gets the candidate by taking in id and orgid
  getCandidate(id, orgid) {
    const url1 = environment.SERVER_URL + AppConstants.GET_CANDIDATE_BY_ID;
    return this.http.get(url1,
      {
        params: {
          candidateid: id.toString(),
          orgid: orgid.toString()
        }
      }
    );
  }

  // updates the candidate
  // updateCandidate(candidate, isProPicFromDrafts,loggedInUsername) {
  //   const url1 = environment.SERVER_URL + AppConstants.UPDATE_CANDIDATE;
  //   const body = new FormData();

  //   if (!isProPicFromDrafts && candidate['profilepicdata'] != null && candidate['profilepicdata'] != undefined
  //   && candidate['profilepicdata'] != "" && candidate['profilepicdata'] != 'null'
  //   && candidate['profilepicdata'] != 'delete') { // Propic Fresh Upload 
  //   body.append('profilepic', candidate['profilepicdata']);
  // }
  //   if (candidate['byteafiles'] != null && candidate['byteafiles'] != undefined
  //     && candidate['byteafiles'] != "" && candidate['byteafiles'] != 'null' && candidate['byteafiles'] != 'delete') {
  //     if (candidate['files'] && candidate['files'].type === 'application/pdf') {
  //       body.append('resumemultipart', candidate['files']);
  //     }
  //   }
  //   if (candidate['templocation']) {
  //     body.append('convertedtmpfileloc', candidate['templocation']);
  //   }
  //   if (candidate['declaration']['relativeworkingdetails'].length > 0) {
  //     candidate['declaration']['relativeworkingdetails'].forEach((e) => {
  //       delete e['mobilenumber'];
  //       delete e['dialcode']
  //     })
  //   }
  //   candidate['email'] = loggedInUsername;
  //   delete candidate['declaration']['workedpreviouslydetails']['supervisor_dialcode'];
  //   delete candidate['declaration']['workedpreviouslydetails']['supervisor_mobilenumber'];
  //   delete candidate['profilepicdata'];
  //   delete candidate['files'];
  //   delete candidate['byteafiles'];
  //   delete candidate['templocation'];
  //   delete candidate['dialcode'];
  //   delete candidate['emedialcode'];
  //   delete candidate['mobilenumber'];
  //   delete candidate['ememobilenumber'];
  //   delete candidate['altmobilenumber'];
  //   delete candidate['altdialcode'];

  //   body.append('candidate', JSON.stringify(candidate));
  //   return this.http.put(url1, body);
  // }
  updateCandidate(candidate, isProPicUpdated, loggedInUsername) {
    const url1 = environment.SERVER_URL + AppConstants.UPDATE_CANDIDATE;
    const body = new FormData();
    if (isProPicUpdated) // If Updated
    {
      if (candidate['profilepicdata'] != null && candidate['profilepicdata'] != undefined
        && candidate['profilepicdata'] != "" && candidate['profilepicdata'] != 'null') { // If Valid Value
        if (candidate['profilepicdata'] === 'delete') { // If Delete
          body.append('profilepicdelete', candidate['profilepicdata']);
        }
        else {
          body.append('profilepic', candidate['profilepicdata']); // Updated value
        }
      }
    }
    if (candidate['byteafiles'] != null && candidate['byteafiles'] != undefined
      && candidate['byteafiles'] != "" && candidate['byteafiles'] != 'null' && candidate['byteafiles'] != 'delete') {
      if (candidate['files'] && candidate['files'].type === 'application/pdf') {
        body.append('resumemultipart', candidate['files']);
      }
    }
    if (candidate['templocation']) {
      body.append('convertedtmpfileloc', candidate['templocation']);
      delete candidate['resumeuploadkey']
    }
    if (candidate['declaration']['relativeworkingdetails'].length > 0) {
      candidate['declaration']['relativeworkingdetails'].forEach((e) => {
        delete e['mobilenumber'];
        delete e['dialcode']
      })
    }
    candidate['email'] = loggedInUsername;
    delete candidate['declaration']['workedpreviouslydetails']['supervisor_dialcode'];
    delete candidate['declaration']['workedpreviouslydetails']['supervisor_mobilenumber'];
    delete candidate['profilepicdata'];
    delete candidate['files'];
    delete candidate['byteafiles'];
    delete candidate['templocation'];
    delete candidate['dialcode'];
    delete candidate['emedialcode'];
    delete candidate['mobilenumber'];
    delete candidate['ememobilenumber'];
    delete candidate['altmobilenumber'];
    delete candidate['altdialcode'];
    delete candidate['flag'];
    
    body.append('candidate', JSON.stringify(candidate));
    return this.http.put(url1, body);
  }

  // gets all the applied jobs of the candidate by taking in id and orgid
  getAllAppliedJobs(id, orgid) {
    const url1 = environment.SERVER_URL + AppConstants.GET_ALL_APPLIED_JOBS_BY_ID;
    return this.http.get(url1 + '?',
      {
        params: {
          candidateid: id.toString(),
          orgid: orgid.toString()
        }
      }
    );

  }

  // checks if the job is applied by the candidate or not
  checkIfJobAlreadyApplied(id, reqid, orgid) {
    const url1 = environment.SERVER_URL + AppConstants.CHECK_IF_JOB_ALREADY_APPLIED;
    return this.http.get(url1,
      {
        params: {
          candidateid: id.toString(),
          reqid: reqid.toString(),
          orgid: orgid.toString()
        }
      }
    );

  }

  // get the questionnaire by taking the id orgid and name
  getQuestionnaireById(parameters) {
    const url = environment.SERVER_URL + AppConstants.GET_COMPLETE_QUESTIONNAIRE_BY_ID;
    return this.http.get(url + '?', {
      params: {
        questionnaireid: parameters.id.toString(),
        orgid: parameters.orgid.toString(),
        name: parameters.name
      }
    });
  }

  // submits the anwer for the questionnaire for that applicant
  SubmitQuestionnaireAnswers(data) {
    const url = environment.SERVER_URL + AppConstants.SUBMIT_APPLICANT_QUESTIONNAIRE_ANSWER;
    return this.http.post(url, data);
  }


  headerProfilePic(element) {
    const url = environment.SERVER_URL + AppConstants.PROFILE_PIC;
    const headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    return this.http
      .get(url, {
        params: element
      })
  }
}